import React from "react";
import debounce from "debounce";

const useDebounce = (callback: any, delay: any) => {
  const callbackRef = React.useRef(callback);
  React.useLayoutEffect(() => {
    callbackRef.current = callback;
  });
  return React.useMemo(
    () => debounce((...args: any) => callbackRef.current(...args), delay),
    [delay]
  );
};
export default useDebounce;
